import { RolInput } from 'src/app/model.ts/rol.model';
import { Warehouse, WarehouseInput } from './establishment.model';
import { Person, PersonInput } from './person.model';
import { Rol } from './rol.model';
import { ProcessTask, ProcessTaskInput } from './supplying.model';

export interface User {
    id?: string;
    userName?: string;
    password?: string;
    pin?: string;
    warehouse?: Warehouse;
    active?: boolean;
    resetPassword?: boolean;
    roles?: Rol[];
    oldPassword?: string;
    person?: Person;
    warehouses?: Warehouse[];
    processTasks?: ProcessTask[];
    userSupplyId?: string;
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
}
export interface UserInput {
    id?: string;
    userName?: string;
    password?: string;
    pin?: string;
    warehouse?: WarehouseInput;
    active?: boolean;
    resetPassword?: boolean;
    roles?: RolInput[];
    oldPassword?: string;
    person?: PersonInput;
    warehouses?: WarehouseInput[];
    processTasks?: ProcessTaskInput[];
    userSupplyId?: string;
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
}
export interface UserPasswordInput {
    id?: string;
    userName?: string;
    password?: string;
    resetPassword?: boolean;
    oldPassword?: string;
}
export interface UserClient {
    id?: string;
    userName?: string;
    password?: string;
    active?: boolean;
    dni?: string;
    fullName?: string;
}

export interface UserClientInput {
    id?: string;
    userName?: string;
    password?: string;
    dni?: string;
    referenceId?: string;
    priceList?: any[];
    discountList?: string;
    active?: boolean;
    fullName?: string;
}

export enum PriceTypeEnum {
    LIST_PRICE = 'LIST_PRICE',
    COMMERCIAL_PRICE = 'COMMERCIAL_PRICE',
    SALES_PRICE = 'SALES_PRICE',
    HEADSHIP_PRICE = 'HEADSHIP_PRICE',
    BEST_PRICES = 'BEST_PRICES',
    COST_PRICE = 'COST_PRICE',
    VOLUME_PRICE = 'VOLUME_PRICE',
    WAREHOUSE_PRICE = 'WAREHOUSE_PRICE'
}

export enum FormMode {
    CREATE = 'CREATE',
    EDIT = 'EDIT'
}
